import React, {useEffect, useState} from "react";
import WorkScheduleDay from "./work-schedule-day.jsx";
import moment from "moment";

const WorkScheduleWeek = ({ days, schedules }) => {
    const [intervalsByDay, setIntervalsByDay] = useState([]);

    const groupIntervalsByDay = (day) => {
        return intervalsByDay.flatMap(i => i.filter(it => it.startDay === day.monthday));
    }

    useEffect(() => {
        const fillIntervals = () => {
            let onePersonSchedule = []

            if(schedules.length){
                onePersonSchedule = [...schedules.filter((el) => el.userId === schedules[0].userId).sort((a,b) => new Date(a.startDate) - new Date(b.startDate))];
            }

            if (onePersonSchedule.length) {
                const intervals = days.map(day => {
                    const intervals = [];

                    const maxDays = onePersonSchedule.length > 7 ? 7 : onePersonSchedule.length;
                    for (let i = 0; i < maxDays; i++) {
                        const { startDate, endDate } = onePersonSchedule[i];

                        const startFormatted = moment(startDate).format('HH:mm');
                        const endFormatted = moment(endDate).format('HH:mm');

                        const startHour = moment(startFormatted, 'HH:mm').hour();
                        const endHour = moment(endFormatted, 'HH:mm').hour();
                        const startDay = moment(startDate).date();
                        const endDay = moment(endDate).date();

                        if (startDay === day.monthday) {
                            intervals.push({
                                startHour,
                                endHour: startHour >= endHour ? 24 : endHour,
                                startFormatted,
                                endFormatted,
                                startDay,
                                endDay,
                            });

                            if (endDay !== day.monthday) {
                                intervals.push({
                                    startHour: 0,
                                    endHour,
                                    startFormatted: null,
                                    endFormatted: null,
                                    startDay: endDay,
                                    endDay,
                                });
                            }
                        }
                    }

                    return intervals;
                });

                setIntervalsByDay(intervals);
            }
        }

        fillIntervals();
    }, [schedules, days]);

    return (
        <>
            {days.map((day, idx) => (
                <WorkScheduleDay key={idx} completeDate={day.completeDate} hasSchedules={schedules?.length > 0} intervals={groupIntervalsByDay(day)}/>
            ))}
        </>
    );
};

export default WorkScheduleWeek;
